<template>
  <div class="mgt-30 no-board-data t-center">
    <!-- {{suggestionBox}}
    {{contents}} -->
    <img
      src="/images/board/no-board-data.svg"
      alt=""
      class="mgx-auto dkdk mgb-24"
      v-if="contents === '' && suggestionBox === false"
    />
    <div v-if="contents && suggestionBox === false">
      <div class="t-subtitle3 font-m">{{ $t("3339") }}</div>
      <div class="t-body3 font-r t-color-bodyGrayA mgt-8">{{ $t("3340") }}</div>
    </div>
    <div v-else>
      <div v-if="suggestionBox === false" class="t-subtitle3 font-m">
        {{ $t("3336") }}
      </div>
      <div
        v-if="suggestionBox === false"
        class="t-body3 font-r t-color-bodyGrayA mgt-8"
      >
        {{ $t("3337") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["filterCategory", "selectedMenuType", "contents", "suggestionBox"],

  name: "",
};
</script>

<style scoped>
.no-board-data img {
  height: 143px;
  width: auto;
}
</style>